/**
 * @file: getImageMask.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export function getImageMask({
  previewWidth,
  previewHeight,
  imageWidth,
  imageHeight,
}: {
  previewWidth: number;
  previewHeight: number;
  imageWidth: number;
  imageHeight: number;
}) {
  const maskRect = { x: 0, y: 0, width: 0, height: 0 };
  if (imageWidth / imageHeight > previewWidth / previewHeight) {
    maskRect.width = previewWidth;
    maskRect.height = previewWidth * (imageHeight / imageWidth);
    maskRect.y = (previewHeight - maskRect.height) / 2;
  } else {
    maskRect.height = previewHeight;
    maskRect.width = previewHeight * (imageWidth / imageHeight);
    maskRect.x = (previewWidth - maskRect.width) / 2;
  }
  return maskRect;
}
